<template>
    <div class="box">
        <img class="logo-icon" src="@/static/invoice_logo_new.png" alt="invoice_logo.png">
        <span class="app-name">Swift Invoice</span>
        <el-dropdown class="lang-switcher" trigger="click" @command="switchLang">
            <span class="lang-trigger">
                <i class="el-icon-lang el-icon-s-operation"></i>
                <span class="lang-current">{{currentLangLabel}}</span>
                <i class="el-icon-arrow-down lang-caret"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="lang in langList"
                                  :key="lang.code"
                                  :command="lang.code"
                                  :class="{'is-active': $i18n.locale === lang.code}">
                    {{lang.label}}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>


<script>
    const LANG_LIST = [
        {code: 'en', label: 'English'},
        {code: 'zh', label: '中文'},
        {code: 'fr', label: 'Français'},
        {code: 'de', label: 'Deutsch'},
        {code: 'es', label: 'Español'},
        {code: 'ja', label: '日本語'},
        {code: 'ms', label: 'Bahasa Melayu'},
        {code: 'id', label: 'Bahasa Indonesia'},
        {code: 'tl', label: 'Filipino'}
    ];

    export default {
        data() {
            return {
                langList: LANG_LIST
            };
        },
        computed: {
            currentLangLabel() {
                const found = LANG_LIST.find(l => l.code === this.$i18n.locale);
                return found ? found.label : 'English';
            }
        },
        methods: {
            switchLang(lang) {
                if (this.$i18n.locale === lang) {
                    return;
                }
                this.$i18n.locale = lang;
            }
        }
    }
</script>

<style scoped>
    .box {
        display: flex;
        align-items: center;
        text-align: left;
        background: transparent;
        padding: 0;
    }

    .logo-icon {
        width: 38px;
        height: 38px;
        border-radius: 8px;
    }

    .app-name {
        color: #14234a;
        font-size: 22px;
        font-weight: 800;
        margin-left: 10px;
    }

    .lang-switcher {
        margin-left: auto;
    }

    .lang-trigger {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 10px;
        border: 1px solid #d8dfea;
        border-radius: 6px;
        color: #566584;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        background: #fff;
        transition: border-color 160ms ease, color 160ms ease;
    }

    .lang-trigger:hover {
        border-color: #0d6dfd;
        color: #0d6dfd;
    }

    .lang-current {
        max-width: 110px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lang-caret {
        font-size: 11px;
    }
</style>
